<template>
	<div id="app" :class="{ margin: $isApp }">
		<transition :name="pageTransition">
			<router-view />
		</transition>
	</div>
</template>

<script>
export default {
	name: 'Recyculator',
	data() {
		return {
			pageTransition: 'slide'
		}
	},
	methods: {
		getPageTitle(route) {
			switch (route.params.tab) {
				case 'plastic':
					return 'Plastic Bottles'
				case 'aluminium':
					return 'Aluminium Cans'
				case 'glass':
					return 'Glass Bottles'
				case 'results':
					return 'Your Results'
				default:
					return route.name
			}
		},
		trackPage(route) {
			const title = this.getPageTitle(route)
			this.$gtag.pageview({
				page_title: title,
				page_path: route.path,
				page_location: window.location.href
			})
		}
	},
	watch: {
		$route(to, from) {
			if (to.meta.overlay) {
				this.pageTransition = 'overlay-in'
			} else if (from.meta.overlay) {
				this.pageTransition = 'overlay-out'
			} else {
				this.pageTransition =
					to.meta.order > from.meta.order ? 'slide-left' : 'slide-right'
			}

			// Track pageview
			this.trackPage(to)
		}
	},
	created() {
		// Initial pageview track on app load
		this.trackPage(this.$route)
	}
}
</script>

<style lang="scss">
@import '~scss/typography';

html,
body,
#app {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	overflow: hidden;
	position: relative;
}

#app.margin {
	// add bottom margin if in COEX app
	height: calc(100% - 40px);
}

* {
	@extend %body;
	box-sizing: border-box;
}
</style>

<style lang="scss" scoped>
// Page transitions

.slide {
	&-left-enter,
	&-right-leave-to {
		transform: translateX(100%);
	}
	&-left-leave-to,
	&-right-enter {
		transform: translateX(-100%);
	}

	&-left,
	&-right {
		&-enter-active,
		&-leave-active {
			transition: transform 0.5s;
		}
	}
}

.overlay {
	&-in-enter,
	&-out-leave-to {
		transform: translateY(100%);
		z-index: 1;
	}

	&-in,
	&-out {
		&-enter-active,
		&-leave-active {
			transition: transform 0.5s;
		}
	}
}
</style>
